import { Settings } from "luxon";

Settings.defaultZoneName = "Europe/Oslo";
